"use strict";
"use client";

/* eslint-disable react/no-array-index-key */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _rcResizeObserver = _interopRequireDefault(require("rc-resize-observer"));
var _useEvent = _interopRequireDefault(require("rc-util/lib/hooks/useEvent"));
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _useCSSVarCls = _interopRequireDefault(require("../config-provider/hooks/useCSSVarCls"));
var _useItems = _interopRequireDefault(require("./hooks/useItems"));
var _useResizable = _interopRequireDefault(require("./hooks/useResizable"));
var _useResize = _interopRequireDefault(require("./hooks/useResize"));
var _useSizes = _interopRequireDefault(require("./hooks/useSizes"));
var _Panel = require("./Panel");
var _SplitBar = _interopRequireDefault(require("./SplitBar"));
var _style = _interopRequireDefault(require("./style"));
var Splitter = function Splitter(props) {
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'horizontal' : _props$layout,
    children = props.children,
    rootClassName = props.rootClassName,
    onResizeStart = props.onResizeStart,
    onResize = props.onResize,
    onResizeEnd = props.onResizeEnd;
  var _react$default$useCon = _react["default"].useContext(_configProvider.ConfigContext),
    getPrefixCls = _react$default$useCon.getPrefixCls,
    direction = _react$default$useCon.direction,
    splitter = _react$default$useCon.splitter;
  var prefixCls = getPrefixCls('splitter', customizePrefixCls);
  var rootCls = (0, _useCSSVarCls["default"])(prefixCls);
  var _ref = (0, _style["default"])(prefixCls, rootCls),
    _ref2 = _slicedToArray(_ref, 3),
    wrapCSSVar = _ref2[0],
    hashId = _ref2[1],
    cssVarCls = _ref2[2];
  // ======================== Direct ========================
  var isVertical = layout === 'vertical';
  var isRTL = direction === 'rtl';
  var reverse = !isVertical && isRTL;
  // ====================== Items Data ======================
  var items = (0, _useItems["default"])(children);
  // >>> Warning for uncontrolled
  if (process.env.NODE_ENV !== 'production') {
    var warning = (0, _warning.devUseWarning)('Splitter');
    var existSize = false;
    var existUndefinedSize = false;
    items.forEach(function (item) {
      if (item.size !== undefined) {
        existSize = true;
      } else {
        existUndefinedSize = true;
      }
    });
    if (existSize && existUndefinedSize && !onResize) {
      process.env.NODE_ENV !== "production" ? warning(false, 'usage', 'When part of `Splitter.Panel` has `size`, `onResize` is required or change `size` to `defaultSize`.') : void 0;
    }
  }
  // ====================== Container =======================
  var _ref3 = (0, _react.useState)(),
    _ref4 = _slicedToArray(_ref3, 2),
    containerSize = _ref4[0],
    setContainerSize = _ref4[1];
  var onContainerResize = function onContainerResize(size) {
    var offsetWidth = size.offsetWidth,
      offsetHeight = size.offsetHeight;
    var containerSize = isVertical ? offsetHeight : offsetWidth;
    // Skip when container has no size, Such as nested in a hidden tab panel
    // to fix: https://github.com/ant-design/ant-design/issues/51106
    if (containerSize === 0) {
      return;
    }
    setContainerSize(containerSize);
  };
  // ========================= Size =========================
  var _ref5 = (0, _useSizes["default"])(items, containerSize),
    _ref6 = _slicedToArray(_ref5, 6),
    panelSizes = _ref6[0],
    itemPxSizes = _ref6[1],
    itemPtgSizes = _ref6[2],
    itemPtgMinSizes = _ref6[3],
    itemPtgMaxSizes = _ref6[4],
    updateSizes = _ref6[5];
  // ====================== Resizable =======================
  var resizableInfos = (0, _useResizable["default"])(items, itemPxSizes);
  var _ref7 = (0, _useResize["default"])(items, resizableInfos, itemPtgSizes, containerSize, updateSizes),
    _ref8 = _slicedToArray(_ref7, 5),
    onOffsetStart = _ref8[0],
    onOffsetUpdate = _ref8[1],
    onOffsetEnd = _ref8[2],
    onCollapse = _ref8[3],
    movingIndex = _ref8[4];
  // ======================== Events ========================
  var onInternalResizeStart = (0, _useEvent["default"])(function (index) {
    onOffsetStart(index);
    onResizeStart === null || onResizeStart === void 0 ? void 0 : onResizeStart(itemPxSizes);
  });
  var onInternalResizeUpdate = (0, _useEvent["default"])(function (index, offset) {
    var nextSizes = onOffsetUpdate(index, offset);
    onResize === null || onResize === void 0 ? void 0 : onResize(nextSizes);
  });
  var onInternalResizeEnd = (0, _useEvent["default"])(function () {
    onOffsetEnd();
    onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(itemPxSizes);
  });
  var onInternalCollapse = (0, _useEvent["default"])(function (index, type) {
    var nextSizes = onCollapse(index, type);
    onResize === null || onResize === void 0 ? void 0 : onResize(nextSizes);
    onResizeEnd === null || onResizeEnd === void 0 ? void 0 : onResizeEnd(nextSizes);
  });
  // ======================== Styles ========================
  var containerClassName = (0, _classnames["default"])(prefixCls, className, "".concat(prefixCls, "-").concat(layout), _defineProperty({}, "".concat(prefixCls, "-rtl"), isRTL), rootClassName, splitter === null || splitter === void 0 ? void 0 : splitter.className, cssVarCls, rootCls, hashId);
  // ======================== Render ========================
  var maskCls = "".concat(prefixCls, "-mask");
  var stackSizes = _react["default"].useMemo(function () {
    var mergedSizes = [];
    var stack = 0;
    for (var i = 0; i < items.length; i += 1) {
      stack += itemPtgSizes[i];
      mergedSizes.push(stack);
    }
    return mergedSizes;
  }, [itemPtgSizes]);
  var mergedStyle = Object.assign(Object.assign({}, splitter === null || splitter === void 0 ? void 0 : splitter.style), style);
  return wrapCSSVar(/*#__PURE__*/_react["default"].createElement(_rcResizeObserver["default"], {
    onResize: onContainerResize
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: mergedStyle,
    className: containerClassName
  }, items.map(function (item, idx) {
    // Panel
    var panel = /*#__PURE__*/_react["default"].createElement(_Panel.InternalPanel, Object.assign({}, item, {
      prefixCls: prefixCls,
      size: panelSizes[idx]
    }));
    // Split Bar
    var splitBar = null;
    var resizableInfo = resizableInfos[idx];
    if (resizableInfo) {
      var ariaMinStart = (stackSizes[idx - 1] || 0) + itemPtgMinSizes[idx];
      var ariaMinEnd = (stackSizes[idx + 1] || 100) - itemPtgMaxSizes[idx + 1];
      var ariaMaxStart = (stackSizes[idx - 1] || 0) + itemPtgMaxSizes[idx];
      var ariaMaxEnd = (stackSizes[idx + 1] || 100) - itemPtgMinSizes[idx + 1];
      splitBar = /*#__PURE__*/_react["default"].createElement(_SplitBar["default"], {
        index: idx,
        active: movingIndex === idx,
        prefixCls: prefixCls,
        vertical: isVertical,
        resizable: resizableInfo.resizable,
        ariaNow: stackSizes[idx] * 100,
        ariaMin: Math.max(ariaMinStart, ariaMinEnd) * 100,
        ariaMax: Math.min(ariaMaxStart, ariaMaxEnd) * 100,
        startCollapsible: resizableInfo.startCollapsible,
        endCollapsible: resizableInfo.endCollapsible,
        onOffsetStart: onInternalResizeStart,
        onOffsetUpdate: function onOffsetUpdate(index, offsetX, offsetY) {
          var offset = isVertical ? offsetY : offsetX;
          if (reverse) {
            offset = -offset;
          }
          onInternalResizeUpdate(index, offset);
        },
        onOffsetEnd: onInternalResizeEnd,
        onCollapse: onInternalCollapse
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "split-panel-".concat(idx)
    }, panel, splitBar);
  }), typeof movingIndex === 'number' && (/*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames["default"])(maskCls, "".concat(maskCls, "-").concat(layout))
  })))));
};
if (process.env.NODE_ENV !== 'production') {
  Splitter.displayName = 'Splitter';
}
var _default = exports["default"] = Splitter;